<template>
<div class="chapter">
<div class="inner_page">
<div id="Acknowledgements">
<p class="fm-title"><a id="page_8">Acknowledgements</a></p><a id="page_8">
<p class="noindent1"><span class="dropcap">I</span> would like to thank anyone who has assisted me over the years with information and photographs for my publications. For this book I would like to thank John Cloake, Gavin Goh, Ted Nevill at Cody Images, Mariusz Zimny and Wawrzyniec Markowski.</p>
<p class="para">All the photographs apart from those listed below are from the Philip Jowett collection.</p>
<div class="table">
<p class="noindent2">John Cloake: p. 122 (top)</p>
<p class="noindent2">Cody Images: pp. 96 (top) and 114 (top)</p>
<p class="noindent2">Gavin Goh: p. 85 (top)</p>
<p class="noindent2">Wawrzyniec Markowski: pp. 48 (top), 80 and 97 (bottom)</p>
<p class="noindent2">Mariusz Zimny: p. 60 (top)</p>
</div>
</a></div><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Acknowledgements.vue?952481e4